import React from 'react';
import PropTypes from 'prop-types';

const NavButton = ({ handleAction, show, modifier }) => (
  <>
    {show && (
      <div
        role="button"
        className={`slider__button slider__button--gallery slider__button--${modifier}`}
        onClick={handleAction}>
        <div
          className={`arrow arrow--${modifier === 'next' ? 'right' : 'left'}`}
          data-testid={`navButton-${modifier}`}
        />
      </div>
    )}
  </>
);

NavButton.propTypes = {
  handleAction: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  modifier: PropTypes.string.isRequired
};

export default NavButton;
